export default "__VITE_ASSET__C8Yyn2iS__"